@@include("./vendors/slick/slick.js");

var windowsPC = new RegExp('Windows NT');
var chromeOS = new RegExp('CrOS');

$('document').ready(function(){
//fashion carousel
  $('.carousel').slick({
    infinite: true,
    arrows: false,
    centerMode: true,
    centerPadding: '30%',
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 1540,
        settings: {
          centerPadding: '25%',
        }
      },
      {
      	breakpoint: 1024,
      	settings: {
      		autoplay: false,
      	}
      },
      {
        breakpoint: 800,
        settings: {
          centerPadding: '20%',
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: '12%',
        }
      }
    ]
  });
//make fashion carousel move when next/prev slides are clicked
  $('.slick-slider').on('click', '.slick-slide', function (e) {
    e.stopPropagation();
    var index = $(this).data("slick-index");
    if ($('.slick-slider').slick('slickCurrentSlide') !== index) {
      $('.slick-slider').slick('slickGoTo', index);
    }
  });

//init controller for page
var controller = new ScrollMagic.Controller({});


if ($('html').hasClass('no-touchevents') || windowsPC.test(navigator.userAgent) || chromeOS.test(navigator.userAgent)) {
  var lines;
//drawing line tweens
  $('.height-line').each(function(){
    var tweenDrawLine = new TweenLite.fromTo(this, 2, {height: 0}, {height: '100%'});
    lines = new ScrollMagic.Scene({triggerHook: 0.75, triggerElement: this, offset: -100})
      .setTween(tweenDrawLine)
      .addTo(controller);
  });
  $('.height-line-top').each(function(){
    var tweenDrawLine = new TweenLite.fromTo(this, 5, {height: 0}, {height: '100%'});
    new ScrollMagic.Scene({triggerHook: 1, triggerElement: this, offset: -400})
      .setTween(tweenDrawLine)
      .addTo(controller);
  });
  $('.width-line').each(function(){
    var tweenDrawLine = new TweenLite.fromTo(this, 2, {width: 0}, {width: '100%'});
    new ScrollMagic.Scene({triggerHook: 0.75, triggerElement: this, offset: -100})
      .setTween(tweenDrawLine)
      .addTo(controller);
  });
  $('.width-line-slow').each(function(){
    var tweenDrawLine = new TweenLite.fromTo(this, 5, {width: 0}, {width: '100%'});
    new ScrollMagic.Scene({triggerHook: 0.75, triggerElement: this, offset: -100})
      .setTween(tweenDrawLine)
      .addTo(controller);
  });
  $('.width-line-top').each(function(){
    var tweenDrawLine = new TweenLite.fromTo(this, 5, {width: 0}, {width: '100%'});
    new ScrollMagic.Scene({triggerHook: 1, triggerElement: this, offset: -400})
      .setTween(tweenDrawLine)
      .addTo(controller);
  });

//move in hex codes in the color sections
  $('.hex').each(function(){
    var moveRight = new TweenLite.fromTo(this, 1, {left: '-60px'}, {left: '10%'});
    new ScrollMagic.Scene({triggerHook: 1, triggerElement: this})
      .setTween(moveRight)
      .addTo(controller);
  });

//general fade in content tweens
  $('*[data-animation="fadeup"]').each(function(){
    var tweenFadeUp = new TweenLite.from(this, 0.66, {transform: 'translate3d(0, 25px, 0)', opacity: 0});
    var scene = new ScrollMagic.Scene({triggerHook: 0.75, triggerElement: this, offset: -150, reverse: false})
      .setTween(tweenFadeUp)
      .addTo(controller);
  });
  $('*[data-animation="fadeupalot"]').each(function(){
    var tweenFadeUp = new TweenLite.from(this, 0.66, {transform: 'translate3d(0, 50px, 0)', opacity: 0});
    var scene = new ScrollMagic.Scene({triggerHook: 0.75, triggerElement: this, offset: -150, reverse: false})
      .setTween(tweenFadeUp)
      .addTo(controller);
  });
  $('*[data-animation="fadein"]').each(function(){
    var tweenFadeIn = new TweenLite.from(this, 1, {opacity: 0});
    var scene = new ScrollMagic.Scene({triggerHook: 0.75, triggerElement: this, offset: -150, reverse: false})
      .setTween(tweenFadeIn)
      .addTo(controller);
  });
}


//black quote (blockquote) section
//writeOut() displays one string after the other
//animation happens only if >= tablet, if not, just add quote to blockquote
  if (($('html').hasClass('no-touchevents') || windowsPC.test(navigator.userAgent) || chromeOS.test(navigator.userAgent)) && $(window).width() >= 768 ) {
    var strings = [
      '<span>What was once</span>',
      '<span>a design style</span>',
      '<span>that was thoughtful,</span>',
      '<span>balanced, & clean</span>',
      '<span>has turned<span>',
      '<span><span class="decoration">thoughtless</span>, cold,</span>',
      '<span>& commercial.</span>',
      '<span>The loss</span>',
      '<span>for the intent</span>',
      '<span>has <span class="decoration">damaged</span> the</span>',
      '<span>style as a whole.</span>'
    ];
    function writeOut(i){
      $(strings[i]).hide().appendTo('blockquote').each(function (j) {
        $(this).delay(333 * j).css({
          display: 'block',
          opacity: 0
        }).animate({
          opacity: 1
        }, 333);
      }).promise().done(function (){
        if (i < strings.length){
          writeOut(i+=1);
          i+=1;
        }
      });
    }
    var quoteScene = new ScrollMagic.Scene({triggerElement: '.black-quote', reverse: false})
      .on('start', function (e){
        writeOut(0);
      })
      .addTo(controller);
  } else {
    $('blockquote').append(
      'What was once a design style that was thoughtful, balanced, & clean has turned <span class="decoration">thoughtless</span>, cold, & commercial. The loss for the intent has <span class="decoration">damaged</span> the style as a whole.'
    );
  }


//balloons section
//animation happens only if >= tablet, if not, no balloons
  if ($(window).width() >= 768) {
    var balloonsHeight = $('.balloons').innerHeight();
    var balloonTween = new TimelineLite();
      $('.balloon').each(function(){
        var randomPercent = (Math.floor(Math.random() * (100 + 20 + 1)) - 20) + '%';
        balloonTween.to(this, 1, {left: randomPercent, top: '-' + balloonsHeight}, '-=0.75');
      })
    new ScrollMagic.Scene({triggerHook: 0.75, triggerElement: ".balloons", duration: balloonsHeight})
        .setTween(balloonTween)
        .addTo(controller);
  }


//these animations r everywhere!

  $('.strike, a').each(function(){
    $(this).addClass('decoration');
  });

  //magazines section, fade in one magazine after the other
  var magazineTween = new TimelineLite()
    .from('.magazine-2', 0.9, {opacity: 0}, '-=0.75')
    .from('.magazine-3', 0.9, {opacity: 0}, '-=0.75')
    .from('.magazine-4', 0.9, {opacity: 0}, '-=0.75')
    .from('.magazine-5', 0.9, {opacity: 0}, '-=0.75')
    .from('.magazine-6', 0.9, {opacity: 0}, '-=0.75');
  new ScrollMagic.Scene({triggerElement: '.magazines'})
      .setTween(magazineTween)
      .addTo(controller);

});
